
import React, { useState, useEffect, useRef, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Chip } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StorefrontIcon from '@mui/icons-material/Storefront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AuthService from "../../Authentication_usertypes/auth.service";
import AlertService from "../../../components/Alerts/alerts";
import DashboardService from "../dashboard.service";
import { useNavigate } from 'react-router-dom'
import Alerts from "../../../components/Alerts/alerts";
import {
  Box, Card, Typography, TextField, Radio, RadioGroup, FormControlLabel,
  Button, Divider, Checkbox, CircularProgress, Select, MenuItem, FormControl, InputLabel, Dialog,
  DialogTitle, DialogContent, DialogActions, IconButton, createTheme
} from '@mui/material'
import { styled } from '@mui/system'
import AddressPopup from './AddressPopup';
import deliveryIcon from '../../../assets/delivery.svg';
import pickup from '../../../assets/pickup.svg';
import { useCart } from '../../../context/CartContext.js';

const theme = createTheme({
  width: '100%',
  maxWidth: '500px',
  palette: {
    primary: {
      main: '#3488A4',
      light: '#E3F2FD',
    },
    text: {
      primary: '#37474F',
      secondary: '#78909C',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    }
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      letterSpacing: 0,
      color: '#3488A4',
    },
  },
});

const StyledCard = styled(Box)(({ theme }) => ({
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  borderRadius: '8px',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}))
const SummaryItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
}))

const DeliveryMethodButton = styled(Button)(({ theme, active }) => ({
  flex: 1,
  borderRadius: '20px',
  backgroundColor: active ? '#3488A4' : 'transparent',
  color: active ? 'white' : 'black',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: active ? 'gray' : 'rgba(0, 0, 0, 0.04)',
  },
  '& .MuiButton-startIcon': {
    margin: 0,
    marginBottom: '10px',
  },
  '& .MuiButton-startIcon > *:first-of-type': {
    fontSize: '32px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '10px',
    '& .MuiButton-startIcon > *:first-of-type': {
      fontSize: '24px',
    },
  },
}));



const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  borderRadius: '8px',
  padding: '12px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))


const center = {
  lat: 3.139003,
  lng: 101.686855
}


const EditLink = styled(Button)({
  color: '#0096b2',
  textTransform: 'none',
  '&:hover': {
    background: 'none',
  },
})

const PlaceOrderButton = styled(Button)({
  backgroundColor: '#0096b2',
  color: 'white',
  padding: '15px',
  '&:hover': {
    backgroundColor: '#007a8c',
  },
})

const mapContainerStyle = {
  width: '100%',
  height: '400px'
}

export default function CheckoutPage({ onClose, setIsCartOpen, handleTerms, handleRefundPolicy, handlePrivacyPolicy }) {
  const { cartState, fetchCartData } = useCart();
  const router = useNavigate()
  const [loading, setLoading] = useState(true)
  const [cartData, setCartData] = useState([])
  const [addressesList, setAddressesList] = useState([])
  const [selectedAddress, setSelectedAddress] = useState('')
  const [deliveryMethod, setDeliveryMethod] = useState('delivery')
  const [deliveryMethods, setDeliveryMethods] = useState([])
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState('Normal')
  const [priorityTip, setPriorityTip] = useState(0)
  const [couponCode, setCouponCode] = useState('')
  const [calculations, setCalculations] = useState({})
  const [userDetails, setUserDetails] = useState(null)
  const [userBalance, setUserBalance] = useState(null)
  const [openAddressDialog, setOpenAddressDialog] = useState(false)
  const [newAddress, setNewAddress] = useState({ label: '', address: '', block: '', unit: '' })
  const [selectedLocation, setSelectedLocation] = useState(null)
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [DistanceFormula, setDistanceFormula] = useState(0);
  const [Prioritize, setPrioritize] = useState([]);
  const [Address, setAddress] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handlePickup = async (pickupMethod) => {
    //iph todo: 47
    //console.log('Applying Self_Pickup:', pickupMethod);
    let status = false;
    if (pickupMethod === 'selfPickUp') {
      status = true;
    }
    try {
      // if (status === true) {
      setLoading(true);
      const updateData = {
        "functionName": "GetCartList",
        "postData": {
          "user_id": userDetails?._id,
          "filters": {
            "status": true,
            "coupan_code": couponCode,
            "DeliveryMethod": status ? '' : selectedDeliveryMethod,
            "address_id": status ? '' : Address,
            "self_pickup": status,
            "prioritize": priorityTip,
            "delivery_method": "",
            "quantity": {
              "cart_id": '',
              "quantity": ''
            }
          }

        }
      };
      //iph todo: 47
      //console.log("updateData", updateData);
      DashboardService.GetCartList(updateData).then((response) => {
        setLoading(false); // Set loading state to false after data retrieval
        // Handle response data
        //iph todo: 47
        //console.log("cart Data", response.data);
        if (response.data.message === "Unauthorized") {
          // Perform logout and redirection for unauthorized access
          AuthService.logout();
          router("/login");
          window.location.reload();
        }
        else {
          if (response.data) {
            //iph todo: 47
            //console.log("my updated Item cart Data", response.data.cartData);
            // setBranches(response.data.data); // Set total rows based on response length
            setCartData(response.data.cartData);
            setPrioritize(response.data.Prioritizes);
            setDistanceFormula(response.data.DistanceFormula);
            setAddressesList(response.data.AddressessList);
            setUserDetails(response.data.UserDetails[0]);
            setUserBalance(response.data.UserBalance[0]);
            setCalculations(response.data.Calculations);
          }
        }
      },
        (error) => {
          setLoading(false); // Set loading state to false in case of error
          const errContent =
            (error.response && error.response.data) || error.message || error.toString();
          //iph todo: 47
          //console.log("Net:-", errContent)
          if (errContent) {
            Alerts.swalErrorAlert(errContent)
          }
          else {
            Alerts.swalErrorAlert("Server Error, Please try again later.")
          }
        })
      // } else {
      //   fetchCartData();
      // }
    } catch (err) {
      // setError('Failed to fetch cart data. Please try again.');
      console.error('Error fetching cart data:', err);
    } finally {
      // setLoading(false);
    }
  }

  const fetchCartDataLocal = useCallback(async () => {
    //iph todo: 47
    //console.log("fetchCartDataLocal");
    try {
      setLoading(true)
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const userId = user._id
      const response = await DashboardService.GetCartList({
        functionName: "GetCartList",
        postData: {
          user_id: userId,
          filters: {
            status: false,
            coupan_code: '',
            prioritize: "",
            DeliveryMethod: '',
            address_id: '',
            self_pickup: deliveryMethod !== 'delivery',
            quantity: {
              cart_id: '',
              quantity: ''
            }
          }
        }
      })

      if (response.data.message === "Unauthorized") {
        AuthService.logout()
        router.push("/login")
      } else {
        setCartData(response.data.cartData)
        setDeliveryMethods(response.data.DeliveryMethods)
        setAddressesList(response.data.AddressessList)
        setUserDetails(response.data.UserDetails?.[0])
        setUserBalance(response.data.UserBalance?.[0])
        setCalculations(response.data.Calculations)
        // if (response.data.DeliveryMethods?.length > 0 && !selectedDeliveryMethod) {
        //   setSelectedDeliveryMethod(response.data.DeliveryMethods[0]._id)
        // }
      }
    } catch (error) {
      AlertService.swalErrorAlert('Failed to fetch cart data. Please try again.')
    } finally {
      setLoading(false)
    }
  }, [deliveryMethod, router])

  useEffect(() => {
    // prefer global cart if available
    if (cartState?.cartData?.length) {
      setCartData(cartState.cartData)
      setAddressesList(cartState.AddressessList || [])
      setUserDetails(cartState.UserDetails || null)
      setUserBalance(cartState.UserBalance || null)
      setCalculations(cartState.Calculations || {})
      setDeliveryMethods(cartState.DeliveryMethods || [])
      setLoading(false)
    } else {
      fetchCartDataLocal()
    }
  }, [cartState, fetchCartDataLocal])

  const handleAddress = async (address) => {
    try {
      setLoading(true);
      let status = false;
      if (deliveryMethod !== 'delivery') {
        status = true
      }
      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const userId = user._id
      // console.log("userId: ", userId);

      const updateData = {
        "functionName": "GetCartList",
        "postData": {
          "user_id": userId, //userDetails?._id,
          "filters": {
            "status": true,
            "coupan_code": couponCode,
            "DeliveryMethod": selectedDeliveryMethod,
            "address_id": address,
            "self_pickup": status,
            "prioritize": priorityTip,
            "quantity": {
              "cart_id": '',
              "quantity": ''
            }
          }
        }
      };
      //iph todo: 47
      //console.log("updateData", updateData);
      DashboardService.GetCartList(updateData).then((response) => {
        setLoading(false); // Set loading state to false after data retrieval
        // Handle response data
        //iph todo: 47
        //console.log("cart Data", response.data);
        if (response.data.message === "Unauthorized") {
          // Perform logout and redirection for unauthorized access
          AuthService.logout();
          router("/login");
          window.location.reload();
        }
        else {
          if (response.data) {
            //iph todo: 47
            //console.log("my updated Item cart Data", response.data);
            // setBranches(response.data.data); // Set total rows based on response length
            setCartData(response.data.cartData);
            setAddressesList(response.data.AddressessList);
            setUserDetails(response.data.UserDetails[0]);
            setUserBalance(response.data.UserBalance[0]);
            setCalculations(response.data.Calculations);
          }
        }
      },
        (error) => {
          setLoading(false); // Set loading state to false in case of error
          const errContent =
            (error.response && error.response.data) || error.message || error.toString();
          //iph todo: 47
          //console.log("Net:-", errContent)
          if (errContent) {
            Alerts.swalErrorAlert(errContent)
          }
          else {
            Alerts.swalErrorAlert("Server Error, Please try again later.")
          }
        })
    } catch (err) {
      // setError('Failed to fetch cart data. Please try again.');
      console.error('Error fetching cart data:', err);
    } finally {
      // setLoading(false);
    }
  };
  const handleSelectAddress = (addressId) => {
    setSelectedAddress(addressId);
    setDeliveryAddress(addressId);
    handleAddress(addressId);
    handleCloseAddressDialog();
  };

  const handleDeliveryMethodChange = (event) => {
    setSelectedDeliveryMethod(event.target.value)
    updateCart(event.target.value)
  }

  const handleAddressChange = (event) => {
    setSelectedAddress(event.target.value)
    updateCart(undefined, event.target.value)
  }

  const updateCart = async (newDeliveryMethod = selectedDeliveryMethod, newAddress = selectedAddress) => {
    try {
      setLoading(true)

      const user = JSON.parse(localStorage.getItem('user') || '{}')
      const userId = user._id
      // console.log("userId: ", userId);
      const response = await DashboardService.GetCartList({
        functionName: "GetCartList",
        postData: {
          user_id: userId, //userDetails?._id,
          filters: {
            status: true,
            coupan_code: couponCode,
            DeliveryMethod: newDeliveryMethod,
            address_id: newAddress,
            self_pickup: deliveryMethod !== 'delivery',
            prioritize: priorityTip,
            quantity: {
              cart_id: '',
              quantity: ''
            }
          }
        }
      })

      setCartData(response.data.cartData)
      setCalculations(response.data.Calculations)
    } catch (error) {
      AlertService.swalErrorAlert('Failed to update cart. Please try again.')
    } finally {
      setLoading(false)
    }
  }
  //iph todo: 47
  //console.log("selectedDeliveryMethod", selectedDeliveryMethod)
  const handlePlaceOrder = async () => {
    try {
      if (!isChecked) {
        AlertService.swalErrorAlert('Please Agree to Agreement')
      } else {

        setLoading(true)
        const response = await DashboardService.PlaceOrder({
          functionName: "placeOrder",
          postData: {
            user_id: userDetails?._id,
            pay_topup: userBalance?.total_balance >= calculations.total,
            cartData: cartData?.map(item => ({
              _id: item._id,
              quantity: item.quantity,
              price: item.price,
              total_price: item.total_price,
              category_id: item.category_details._id,
              business_id: item.business_details._id,
              product_id: item.product_details._id,
              variations: item.variations,
              is_reviewed: 0,
            })),
            deliveryMethod,
            selectedDeliveryMethod,
            Addresses: addressesList.filter(address => address._id === selectedAddress),
            priorityTip,
            couponCode,
            total: calculations.grandTotal && !isNaN(parseFloat(calculations.grandTotal)) ? parseFloat(calculations.grandTotal).toFixed(2) : '0.00',
            DistanceFormula: calculations.DistanceFormula,
            Calculations: calculations
          }
        })

        if (response.status === 200) {
          if (userBalance?.total_balance >= calculations.total) {
            AlertService.swalPendingAlert("You are being directed to the payment page to complete the order")
            HandleCartEmpty();
            router('/order-confirmation')
          } else {
            // window.open(response.data.data, '_blank')
            // router(response.data.data)
            // window.open(response.data.data)
            window.location.href = response.data.data;
            HandleCartEmpty();
          }
          fetchCartData()
        }
      }
    } catch (error) {
      AlertService.swalErrorAlert('Failed to place order. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const HandleCartEmpty = async () => {
    try {
      setLoading(true);
      const userString = localStorage.getItem('user');
      const user = JSON.parse(userString);
      const userId = user['_id'];

      const updateData = {
        "functionName": "DeleteCart",
        "postData": {
          "user_id": userId,
          "cart_id": ""
        }
      };
      //iph todo: 47
      //console.log("DeleteCart", updateData);
      DashboardService.DeleteCart(updateData).then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log("cart Data", response.data);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          router("/login");
          window.location.reload();
        } else {
          if (response.data) {
            Alerts.swalPendingAlert('You are being directed to the payment page to complete the order')
          }
        }
      }, (error) => {
        setLoading(false);
        const errContent = (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        } else {
          Alerts.swalErrorAlert("Server Error, Please try again later.")
        }
      })
    } catch (err) {
      console.error('Error emptying cart:', err);
    } finally {
      setLoading(false);
    }
  };

  const renderSelectedAddress = () => {
    if (!deliveryAddress) return null;

    const selectedAddress = addressesList.find(a => a._id === deliveryAddress);
    if (!selectedAddress) return null;

    return (
      <StyledCard>
        <Box sx={{ borderBottom: '1px solid #E2E8F0' }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }}>
            <Typography variant="subtitle1">Deliver To</Typography>
            <Button
              startIcon={<EditIcon />}
              sx={{
                color: '#3488A4',
                textTransform: 'none',
                fontWeight: 500
              }}
              onClick={handleOpenAddressDialog}
            >
              Edit Address
            </Button>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <LocationOnIcon sx={{ color: '#3488A4' }} />
            <Box>
              <Typography variant="body1" sx={{ mb: 1, color: '#1E293B' }}>
                {selectedAddress?.location}
              </Typography>
              {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DirectionsBikeIcon sx={{ color: '#3488A4', fontSize: '1rem' }} />
                <Typography variant="body2" color="text.secondary">
                  Distance from you: {DistanceFormula?.distance?.value
                    ? `${(parseFloat(DistanceFormula?.distance?.value) / 1000).toFixed(2)}km (${parseFloat(calculations?.deliveryTipFee).toFixed(2)})`
                    : ''}
                </Typography>
              </Box> */}
            </Box>
          </Box>
        </Box>
      </StyledCard>
    );
  };


  const handleOpenAddressDialog = () => {
    setOpenAddressDialog(true)
  }

  const handleCloseAddressDialog = () => {
    setOpenAddressDialog(false)
    setNewAddress({ label: '', address: '', block: '', unit: '' })
    setSelectedLocation(null)
  }

  const handleAddNewAddress = async () => {
    fetchCartData()
    // if (!selectedLocation) {
    //   AlertService.swalErrorAlert('Please select a location on the map.')
    //   return
    // }

    // try {
    // setLoading(true)
    // const response = await DashboardService.addAddress({
    //   functionName: "AddAddress",
    //   postData: {
    //     user_id: userDetails?._id,
    //     label: newAddress.label,
    //     address: newAddress.address,
    //     block: newAddress.block,
    //     unit: newAddress.unit,
    //     latitude: selectedLocation.lat,
    //     longitude: selectedLocation.lng
    //   }
    // })

    // if (response.status === 200) {
    // AlertService.swalSuccessAlert("Address added successfully!")
    // setAddressesList([...addressesList, response.data.address])
    // setSelectedAddress(response.data.address._id)
    handleCloseAddressDialog()
    // updateCart(undefined, response.data.address._id)
    // }
    // } catch (error) {
    //   AlertService.swalErrorAlert('Failed to add address. Please try again.')
    // } finally {
    //   setLoading(false)
    // }
  }

  const onMapClick = useCallback((event) => {
    setSelectedLocation({
      lat: event.latLng.lat(),
      lng: event.latLng.lng()
    })
  }, [])


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box maxWidth="lg" sx={{ py: 4, margin: 'auto' }}>
      <Typography variant="h4" sx={{ color: '#0096b2', mb: 4 }}>
        Checkout
      </Typography>

      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={4}>
        {/* Left Column */}
        <Box flex={1}>
          {/* Customer Information */}
          <StyledCard>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h5">Customer information</Typography>
            </Box>
            <SummaryItem>
              <Typography>Name</Typography>
              <Typography>{userDetails?.name}</Typography>
            </SummaryItem>
            <SummaryItem>
              <Typography>Email :</Typography>
              <Typography>{userDetails?.email}</Typography>
            </SummaryItem>
            <SummaryItem>
              <Typography>Phone :</Typography>
              <Typography>{userDetails?.phone}</Typography>
            </SummaryItem>

          </StyledCard>
          <AddressPopup
            key={addressesList?.length}
            open={openAddressDialog}
            onClose={handleCloseAddressDialog}
            addresses={addressesList}
            onSelectAddress={(address) => {
              handleSelectAddress(address._id);
              handleCloseAddressDialog();
            }}
            onAddNew={handleAddNewAddress}
          />
          {/* <StyledCard>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <DeliveryMethodButton
                active={deliveryMethod === 'delivery'}
                onClick={() => {
                  setDeliveryMethod('delivery');
                  handlePickup('delivery');
                }}
                startIcon={<img src={deliveryIcon} alt="Delivery" width="50" height="50" />}
              >
                Delivery
              </DeliveryMethodButton>
              <DeliveryMethodButton
                active={deliveryMethod === 'selfPickUp'}
                onClick={() => {
                  setDeliveryMethod('selfPickUp');
                  handlePickup('selfPickUp');
                }}
                startIcon={<img src={pickup} alt="Self Pickup" width="50" height="50" />}
              >
                Self Pickup
              </DeliveryMethodButton>
            </Box>
          </StyledCard> */}
          {/* Address Selection */}
          {deliveryMethod === 'delivery' && deliveryAddress ? (
            renderSelectedAddress()
          ) : (
            deliveryMethod === 'delivery' &&
            <StyledCard>
              <Typography variant="subtitle1" gutterBottom>Deliver To</Typography>
              <Box
                onClick={handleOpenAddressDialog}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  p: 2,
                  cursor: 'pointer'
                }}
              >
                <LocationOnIcon sx={{ color: '#3488A4', mr: 2 }} />
                <Typography sx={{ flexGrow: 1, color: deliveryAddress ? 'black' : 'grey' }}>
                  {deliveryAddress
                    ? addressesList.find(a => a._id === deliveryAddress)?.location
                    : 'Select your Address'}
                </Typography>
                <IconButton>
                  <AddIcon />
                </IconButton>
              </Box>
            </StyledCard>
          )}

          {/* Delivery Method */}
          {deliveryMethod === 'delivery' &&
            <StyledCard>
              <Typography variant="h6" gutterBottom>Delivery Method</Typography>
              <FormControl fullWidth>
                <InputLabel id="delivery-method-label">Delivery Method</InputLabel>
                <Select
                  labelId="delivery-method-label"
                  value={selectedDeliveryMethod}
                  label="Delivery Method"
                  onChange={handleDeliveryMethodChange}
                >
                  <MenuItem key={'Normal Delivery'} value="Normal">
                    Normal Delivery (Default Rates)
                  </MenuItem>
                  {/*
                  <MenuItem key={'Express Delivery'} value="Express">
                    Express Delivery
                  </MenuItem>
                  */}

                  {/* <MenuItem key={'Lalamove'} value="Lalamove">
                    Lalamove
                  </MenuItem> */}


                  {deliveryMethods?.map((method) => (
                    <MenuItem key={method._id} value={method._id}>
                      {method.method === 'flatShipment' ? "Flat Shipment" : method.method === 'lalamove' ? "Lalamove" : method.method}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </StyledCard>
          }
        </Box>

        {/* Right Column */}
        <Box flex={1}>
          <StyledCard>
            {/* Order Summary Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6">Order Summary</Typography>
              <EditLink onClick={() => { setIsCartOpen(true) }}
              >edit cart</EditLink>
            </Box>

            {/* Product Items */}
            {cartData?.map((item) => (
              <Box key={item._id} sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <img
                  src={item?.product_details?.Images?.[0] || "/placeholder.svg"}
                  alt={item?.product_details?.item_name}
                  width={64}
                  height={64}
                  style={{ borderRadius: 8, marginRight: 16 }}
                />
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="subtitle1">{item.product_details.item_name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Qty: {item.quantity}
                  </Typography>
                </Box>
                {item?.variations && item?.variations.length > 0 && (
                  <Box sx={{
                    mt: 1
                  }}>
                    <Typography variant="body2" color="text.secondary" gutterBottom>Variations:</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {item?.variations.map((variation, index) => (
                        <Chip
                          key={index}
                          label={`${variation.variation_name}: ${variation.variation_type_name} (${variation.variation_price && !isNaN(parseFloat(variation.variation_price)) ? parseFloat(variation.variation_price).toFixed(2) : '0.00'} X ${item.quantity})`}
                          size="small"
                          sx={{
                            backgroundColor: theme.palette.primary.dark,
                            color: theme.palette.primary.contrastText,
                            fontSize: { xs: '0.7rem', sm: '0.8rem' },
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
                <Typography variant="subtitle1">RM{item?.total_price && !isNaN(parseFloat(item.total_price)) ? parseFloat(item.total_price).toFixed(2) : (item?.price && item?.quantity ? (parseFloat(item.price) * parseFloat(item.quantity)).toFixed(2) : '0.00')}</Typography>
              </Box>
            ))}

            {/* Promo Code */}
            <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter promo code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
              />
              <Button variant="outlined" onClick={() => updateCart()}>
                Apply
              </Button>
            </Box>

            <Divider />

            {/* <Typography variant="h6" gutterBottom>Payment Method</Typography>
            <SummaryItem>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountBalanceWalletIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                <Typography>Balance</Typography>
              </Box>
              <Typography>{userBalance?.total_balance && !isNaN(parseFloat(userBalance.total_balance)) ? parseFloat(userBalance.total_balance).toFixed(2) : '0.00'}</Typography>
            </SummaryItem> */}

            {/* <Typography variant="h6" gutterBottom>Branch</Typography>
            <SummaryItem>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <StorefrontIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                <Typography>{cartData?.[0]?.business_details.name}</Typography>
              </Box>
            </SummaryItem> */}

            {/* <Divider sx={{ my: 2 }} /> */}

            <SummaryItem>
              <Typography>Subtotal</Typography>
              <Typography>RM{calculations?.subTotal && !isNaN(parseFloat(calculations?.subTotal)) ? parseFloat(calculations?.subTotal).toFixed(2) : (cartData?.reduce((s, i) => s + ((parseFloat(i?.price) || 0) * (parseFloat(i?.quantity) || 0)), 0)).toFixed(2)}</Typography>
            </SummaryItem>
            {calculations?.discount > 0 && (
              <SummaryItem>
                <Typography>Discount</Typography>
                <Typography>-RM{calculations?.discount && !isNaN(parseFloat(calculations?.discount)) ? parseFloat(calculations?.discount).toFixed(2) : '0.00'}</Typography>
              </SummaryItem>
            )}
            {calculations?.sst > 0 && (
              <SummaryItem>
                <Typography>{calculations?.sst_dynamic_label ? `${calculations?.sst_dynamic_label} (${calculations?.sst_percentage})` : ''}</Typography>
                <Typography>RM{calculations?.sst && !isNaN(parseFloat(calculations?.sst)) ? parseFloat(calculations?.sst).toFixed(2) : '0.00'}</Typography>
              </SummaryItem>
            )}
            <SummaryItem>
              <Typography>Delivery Charges</Typography>
              <Typography>
                {calculations?.free_delivery ? 'Free Delivery' :
                  calculations?.deliveryTipFee === 0 ?
                    (calculations.noShipment === true ? 'No Shipment Available' : 'RM0.00') :
                    (calculations?.deliveryTipFee && !isNaN(parseFloat(calculations?.deliveryTipFee)) ?
                      `RM${parseFloat(calculations?.deliveryTipFee).toFixed(2)}` : 'RM0.00')}
              </Typography>
            </SummaryItem>

            <SummaryItem sx={{ mt: 2, mb: 3 }}>
              <Typography variant="h6">GRAND TOTAL</Typography>
              <Typography variant="h6" color="primary">RM{calculations?.grandTotal && !isNaN(parseFloat(calculations?.grandTotal)) ? parseFloat(calculations?.grandTotal).toFixed(2) : (cartData?.reduce((s, i) => s + ((parseFloat(i?.price) || 0) * (parseFloat(i?.quantity) || 0)), 0)).toFixed(2)}</Typography>
            </SummaryItem>

            {deliveryMethod === 'delivery' &&
              <Box sx={{ bgcolor: '#e8f5e9', p: 2, borderRadius: 2, mb: 2, display: 'flex', alignItems: 'center' }}>
                <CardGiftcardIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                <Typography variant="body2">
                  {calculations?.free_delivery ? 'Congratulation! You will get Free Delivery over this order ' : selectedDeliveryMethod === 'Normal' ? 'Normal delivery: 3-5 working days' : 'Express delivery require 1 working day'}
                </Typography>
              </Box>
            }
          </StyledCard>

          {/* Review & Place Order */}
          <StyledCard>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Review & Place Order
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Please review the order details and payment details before proceeding to confirm your order
            </Typography>

            {/* Agreements */}
            <Box sx={{ mb: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <Typography variant="body2">
                    I agree to the{' '}
                    <Button onClick={handleTerms} style={{ color: '#0096b2', textTransform: 'none', padding: 0, minWidth: 'auto' }}>Terms & conditions</Button>,{' '}
                    <Button onClick={handlePrivacyPolicy} style={{ color: '#0096b2', textTransform: 'none', padding: 0, minWidth: 'auto' }}>Privacy policy</Button> &{' '}
                    <Button onClick={handleRefundPolicy} style={{ color: '#0096b2', textTransform: 'none', padding: 0, minWidth: 'auto' }}>Return policy</Button>
                  </Typography>
                }
              />
            </Box>

            <PlaceOrderButton
              disabled={!isChecked || selectedAddress === '' || selectedDeliveryMethod === ""}
              fullWidth variant="contained" size="large" onClick={() => {
                handlePlaceOrder();
              }}>
              Pay & Place Order
            </PlaceOrderButton>
          </StyledCard>
        </Box>
      </Box>
    </Box>
  )
}